import { createFileRoute } from '@tanstack/react-router';
import { Card, Container, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandWhatsapp,
  IconChartBar,
  IconLockSquare,
  IconRobot,
  IconSpeakerphone,
  IconUsers,
} from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { PublicShell } from '../components/PublicShell';

const FEATURES = [
  {
    title: 'WhatsApp Cloud API',
    body: 'Templates with submission + quality tracking, embedded signup, sessions + 24-h window awareness, media + flow messages, status fan-out via SignalR-equivalent SocketIO.',
    icon: IconBrandWhatsapp,
  },
  {
    title: 'Facebook Messenger',
    body: 'Page OAuth, inbox with read-state and assignment, page-level webhooks, page insights cache.',
    icon: IconBrandFacebook,
  },
  {
    title: 'Instagram DMs',
    body: 'IG Business binding (page-token + ig_business_login flows), DM inbox, reactions + postbacks.',
    icon: IconBrandInstagram,
  },
  {
    title: 'Campaigns',
    body: 'Schedule mass sends, opt-out keywords + suppression list, click tokens, delivery + read funnels.',
    icon: IconSpeakerphone,
  },
  {
    title: 'Bot flows',
    body: 'Visual flow builder, keyword triggers (welcome / is / starts_with / contains_word / contains), AI fallback via your own LLM key.',
    icon: IconRobot,
  },
  {
    title: 'Analytics',
    body: '24h / 7d / 30d KPIs, WhatsApp delivery funnel, top-3 bot flows, page insights timeseries, 5-step connection probe.',
    icon: IconChartBar,
  },
  {
    title: 'Team + permissions',
    body: 'Invite teammates by email, scope per-permission, optional assigned-chats-only mode, full audit log of every change.',
    icon: IconUsers,
  },
  {
    title: 'Privacy + compliance',
    body: 'Tokens encrypted via AES-256-GCM, Meta data-deletion + deauthorize webhooks honored, hard-delete on request, per-vendor data isolation.',
    icon: IconLockSquare,
  },
];

function FeaturesPage() {
  return (
    <PublicShell>
      <Container size="lg" py="xl">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
          <Stack gap="md">
            <Title order={2}>Features</Title>
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
              {FEATURES.map((f) => {
                const Icon = f.icon;
                return (
                  <Card key={f.title}>
                    <Stack gap="xs">
                      <Icon size={26} stroke={1.4} />
                      <Title order={5}>{f.title}</Title>
                      <Text size="sm" c="dimmed">
                        {f.body}
                      </Text>
                    </Stack>
                  </Card>
                );
              })}
            </SimpleGrid>
          </Stack>
        </motion.div>
      </Container>
    </PublicShell>
  );
}

export const Route = createFileRoute('/features')({ component: FeaturesPage });
